import { render, staticRenderFns } from "./locationEditor.vue?vue&type=template&id=c0c51d06&scoped=true"
import script from "./locationEditor.vue?vue&type=script&lang=js"
export * from "./locationEditor.vue?vue&type=script&lang=js"
import style0 from "./locationEditor.vue?vue&type=style&index=0&id=c0c51d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c51d06",
  null
  
)

export default component.exports